"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMatchingOrderQuestionEntity = exports.isFillTheBlankQuestionEntity = exports.isDragToOrderQuestionEntity = exports.isBooleanChoiceQuestionEntity = exports.isMultipleChoiceQuestionEntity = exports.isSingleChoiceQuestionEntity = exports.isTextQuestionEntity = void 0;
var isTextQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "text-question";
};
exports.isTextQuestionEntity = isTextQuestionEntity;
var isSingleChoiceQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "single-choice-question";
};
exports.isSingleChoiceQuestionEntity = isSingleChoiceQuestionEntity;
var isMultipleChoiceQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "multiple-choice-question";
};
exports.isMultipleChoiceQuestionEntity = isMultipleChoiceQuestionEntity;
var isBooleanChoiceQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "boolean-choice-question";
};
exports.isBooleanChoiceQuestionEntity = isBooleanChoiceQuestionEntity;
var isDragToOrderQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "drag-to-order-question";
};
exports.isDragToOrderQuestionEntity = isDragToOrderQuestionEntity;
var isFillTheBlankQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "fill-the-blank-question";
};
exports.isFillTheBlankQuestionEntity = isFillTheBlankQuestionEntity;
var isMatchingOrderQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "matching-order-question";
};
exports.isMatchingOrderQuestionEntity = isMatchingOrderQuestionEntity;
